/**
 * Created by admin on 2018/5/8.
 */
import React from 'react';
import { connect } from 'dva';
import { injectIntl } from 'react-intl';
import DeviceManagement from '../../components/account/DeviceManagement';

const DeviceManage = ({ meeting, login, account, loading, dispatch, intl }) => {
  const {
    userInfo,
    officeInfo,
    areaData,
    serviceType,
    service,
    operation,
    serviceAuthorTypeList,
    serviceAuthorTypeInfo,
    emailError,
    meetingManagers,
    deviceInfo,
    lendDevice,
    deviceModal,
    allAreaDataNoPermission,
    bindRooms
  } = account;
  let obj = {
    emailError,
    serviceType,
    service,
    operation,
    areaData,
    intl,
    dispatch,
    serviceAuthorTypeList,
    serviceAuthorTypeInfo,
    officeInfo,
    meetingManagers,
    userInfo,
    deviceInfo,
    lendDevice,
    deviceModal,
    allAreaDataNoPermission,
    bindRooms
  };
  return <DeviceManagement {...obj} />;
};

const mapStateToProps = state => {
  return Object.assign({}, state, { loading: state.loading.global });
};

export default connect(mapStateToProps)(injectIntl(DeviceManage));



// WEBPACK FOOTER //
// ./src/routes/SystemConfig/DeviceManage.js